# 
# Abstract Scene
# 
# @author David Ronai / Makiopolis.com / @Makio64 
# 

SceneTraveler = require('./SceneTraveler')

class Scene

	constructor:()->
		return

	update:(dt)->
		return

	resize:()->
		return

	transitionIn:()->
		#TweenLite.delayedCall(1, {callback:@onTransitionInComplete});
		@onTransitionInComplete()
		return

	transitionOut:()->
		#TweenLite.delayedCall(1, {callback:@onTransitionOutComplete});
		@onTransitionOutComplete()
		return

	onTransitionInComplete:()->
		return

	onTransitionOutComplete:()->
		SceneTraveler.onTransitionOutComplete()
		@dispose()
		return

	dispose:()->
		return

module.exports = Scene



/** WEBPACK FOOTER **
 ** ./src/coffee/core/scenes/Scene.coffee
 **/